import React from 'react';

const HuePointer = () => {
  return <div className="hue-pointer" />;
};

export default HuePointer;
